import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Box, FlexList, ListItemBase, Text } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { FlexListWrapper } from '@/components/wrappers';

import TransactionItem from '../../TransactionItem';

import useActivitiesList from './hooks/useActivitiesList';

const EMPTY_STATUS = '';

const HEADERS: ListItemBase[] = [
  {
    key: 'provider',
    title: '',
    flex: 5.3,
  },
  {
    key: 'status',
    title: '',
    flex: 3,
  },
  {
    key: 'amount',
    title: 'Amount',
    flex: 2,
  },
  {
    key: 'statusDate',
    title: 'Date',
    flex: 0.7,
    endAlign: true,
  },
  {
    key: 'option',
    title: '',
    flex: 0.5,
  },
];

interface Props {
  accountId: string;
  title?: string;
}

export const ProcessingActivitiesList: React.FC<Props> = ({ accountId, title }) => {
  const { data, isLoading, total } = useActivitiesList({
    accountId,
    page: 0,
    perPage: 100,
    searchString: '',
    hasActiveHold: true,
  });
  const { push } = useHistory();
  const { t } = useTranslation();

  if (!total || !data?.length) {
    return null;
  }

  return (
    <Box margin={{ bottom: 'spacing24' }} data-testid="TransactionsList">
      <Box direction="column" background="module" round="container1Round" pad={{ bottom: 'spacing12' }}>
        <Box
          direction="row"
          data-testid="processing_activities_list_header"
          align="center"
          margin={{ bottom: 'spacing4' }}
          pad={{ horizontal: 'spacing24', top: 'spacing24' }}
        >
          <Box direction="row" style={{ width: '100%' }}>
            <Text size="large" color="blockTitle" weight="bold">
              {title || t('Processing')}
            </Text>
          </Box>
        </Box>
        <FlexListWrapper>
          <FlexList
            testId="processing_activities_list"
            headers={HEADERS}
            rows={[]}
            total={total}
            loading={isLoading}
            footer={
              <Box direction="column">
                {data?.map((item) => (
                  <TransactionItem
                    key={item?.postingId || item?.claimId}
                    category={item.category}
                    type={item?.transactionType}
                    title={item.title}
                    amount={item.amount}
                    status={EMPTY_STATUS}
                    date={item.date}
                    onPick={() =>
                      push(
                        item?.claimId
                          ? ROUTES.TRANSACTION_DETAILS_CLAIM(accountId, item?.claimId)
                          : ROUTES.TRANSACTION_DETAILS_POSTING(
                              accountId,
                              item?.originalFeePostingId || item?.postingId
                            )
                      )
                    }
                  />
                ))}
              </Box>
            }
          />
        </FlexListWrapper>
      </Box>
    </Box>
  );
};
